import { useSelector } from "react-redux";

import { DeploymentPermission } from "constants/permissions";

import {
  useHasBillingPermission,
  useHasDeploymentPermission,
} from "hooks/useHasPermission";

import { getDefaultBillingSettings, getIsLivestockAgent } from "selectors";

export const useCanUseInterestPreview = (): boolean => {
  const hasInterestFeature = useHasDeploymentPermission(
    DeploymentPermission.featureInterest,
  );
  const hasBillingPermission = useHasBillingPermission();
  const isLivestockAgent = useSelector(getIsLivestockAgent);
  const enableInterest = useSelector(getDefaultBillingSettings)?.enableInterest;
  return Boolean(
    hasInterestFeature &&
      enableInterest &&
      hasBillingPermission &&
      isLivestockAgent,
  );
};
